/*
Notes:应收账款转让通知书ajax Api
Date:2018/8/31 by zenglihuai
*/

import axios from 'axios';

export default {
  // 应收账款转让通知书列表
  getTransferAdviceList (search, pageNum = 1, pageSize = 10) {
    const params = {
      pageNum,
      pageSize,
      ...search
    };

    return axios.get(
      '/loanform/blitem/blLoanItemFrontApply/getTranceAdviceList.ht',
      {
        headers: {
          tokenId: localStorage.getItem('dl_tokenId_bl')
        },
        params
      }
    );
  },

  // 应收账款转让通知书详情
  getTransferAdviceDetail (adviceId) {
    const params = {
      adviceId
    };
    return axios.get(
      '/loanform/blitem/blLoanItemFrontApply/getTranceAdviceDetail.ht',
      {
        headers: {
          tokenId: localStorage.getItem('dl_tokenId_bl')
        },
        params
      }
    );
  }
};



// WEBPACK FOOTER //
// ./src/api/transferAdvice.js